// extracted by mini-css-extract-plugin
export default {"container":"Qq_CP","icon":"sjcnV","text":"FbudZ","viewCatalog":"nVAgp","arrow":"Dy3ux","viewDetail":"CuBfg","textBold":"lZMLn"};